'use client'
import { useState, useEffect } from 'react'

export default function LiveDealCount({ fallback, className = 'text-blue-600' }) {
  const [count, setCount] = useState(fallback)
  useEffect(() => {
    fetch('/api/live-stats').then(r => r.json()).then(d => {
      if (d.totalDeals != null) setCount(d.totalDeals)
    }).catch(() => {})
  }, [])
  if (!count) return null
  return <span className={`font-medium ${className}`}>{count.toLocaleString()}</span>
}
